var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTif = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  height: "512pt",
  viewBox: "-79 0 512 512",
  width: "512pt",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m353.101562 485.515625h-353.101562v-485.515625h273.65625l79.445312 79.449219zm0 0",
  fill: "#e3e4d8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m273.65625 0v79.449219h79.445312zm0 0",
  fill: "#d0cebd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m0 353.101562h353.101562v158.898438h-353.101562zm0 0",
  fill: "#baafa9"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m203.035156 397.242188h-52.964844c-4.875 0-8.828124-3.945313-8.828124-8.828126 0-4.882812 3.953124-8.828124 8.828124-8.828124h52.964844c4.871094 0 8.828125 3.945312 8.828125 8.828124 0 4.882813-3.957031 8.828126-8.828125 8.828126zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m176.550781 485.515625c-4.871093 0-8.828125-3.945313-8.828125-8.824219v-88.277344c0-4.882812 3.957032-8.828124 8.828125-8.828124 4.875 0 8.828125 3.945312 8.828125 8.828124v88.277344c0 4.878906-3.953125 8.824219-8.828125 8.824219zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m300.136719 397.242188h-52.964844c-4.871094 0-8.828125-3.945313-8.828125-8.828126 0-4.882812 3.957031-8.828124 8.828125-8.828124h52.964844c4.875 0 8.828125 3.945312 8.828125 8.828124 0 4.882813-3.953125 8.828126-8.828125 8.828126zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m300.136719 441.378906h-52.964844c-4.871094 0-8.828125-3.945312-8.828125-8.828125 0-4.878906 3.957031-8.828125 8.828125-8.828125h52.964844c4.875 0 8.828125 3.949219 8.828125 8.828125 0 4.882813-3.953125 8.828125-8.828125 8.828125zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m247.171875 485.515625c-4.871094 0-8.828125-3.945313-8.828125-8.824219v-88.277344c0-4.882812 3.957031-8.828124 8.828125-8.828124 4.875 0 8.828125 3.945312 8.828125 8.828124v88.277344c0 4.878906-3.953125 8.824219-8.828125 8.824219zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m105.929688 397.242188h-52.964844c-4.871094 0-8.828125-3.945313-8.828125-8.828126 0-4.882812 3.957031-8.828124 8.828125-8.828124h52.964844c4.875 0 8.828124 3.945312 8.828124 8.828124 0 4.882813-3.953124 8.828126-8.828124 8.828126zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m79.449219 485.515625c-4.875 0-8.828125-3.945313-8.828125-8.824219v-88.277344c0-4.882812 3.953125-8.828124 8.828125-8.828124 4.871093 0 8.828125 3.945312 8.828125 8.828124v88.277344c0 4.878906-3.957032 8.824219-8.828125 8.824219zm0 0"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m282.484375 282.484375h-17.65625l-17.65625-44.140625h17.65625v-35.308594h-26.484375l-26.480469-97.105468h-70.621093l-26.484376 97.105468h-26.480468v35.308594h17.652344l-17.652344 44.140625h-17.65625l-8.828125 26.480469h70.621093l8.828126-26.480469h-17.65625l17.65625-44.140625h70.621093l17.652344 44.140625h-17.652344l8.828125 26.480469h70.617188zm-132.414063-79.449219 17.652344-61.792968h17.65625l17.65625 61.792968zm0 0",
  fill: "#28384c"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTif);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tif.ceabe7d5d002adf6c3a2a5d40fc8f097.svg";